import React from 'react'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

export const View = () => (
	<footer>
		<Section fullWidth className={styles.wrapper}>
			<span>© {new Date().getFullYear()} Информационная система Credit.Club</span>
			<span>
				<a
					href='https://storage.yandexcloud.net/creditclub-frontend/static/docs/%D0%A4%D0%BE%D1%80%D0%BC%D0%B0%20%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%BF%D1%80%D0%B5%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F%20%D0%A1%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D0%B0%20%D0%98%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D0%BE%D0%BD%D0%BD%D0%B0%D1%8F%20%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0%20Credit.Club.pdf'
					target='_blank'
					rel='noopener noreferrer nofollow'
					className={styles.link}
				>
					Правила предоставления сервиса
				</a>
			</span>
		</Section>
	</footer>
)
